import { useHead } from "../services/common";

import Carousel from "../components/Carousel";
import Sponsors from "../components/Sponsors";
import { Link } from "easy-page-router/react";
import Icon from "@mdi/react";
import { mdiArrowRight, mdiPlus } from "@mdi/js";
import { EditEvent, EventPreview, useEvents } from "../components/Event";
import { Loading } from "../components";
import moment from "moment";
import { useUser } from "../User";
import { useState } from "react";
import { Galleries, useGalleries } from "../components/Gallery";

export default function Index() {

    useHead({
        title: "T.J. Sokol Poniklá – Sport, kultura a komunita v srdci Krkonoš",
        description: "Oficiální stránky T.J. Sokol Poniklá. Nabízíme sportovní vyžití, kulturní akce, pronájem prostor a ubytování. Zapojte se do dění v Poniklé!"
    });

    const user = useUser();

    const [addEvent, setAddEvent] = useState(false);

    const [events, error, isLoading, reload] = useEvents();
    const [galleries, galleriesError, galleriesIsLoading, galleriesReload] = useGalleries();

    const today = moment().format("YYYY-MM-DD");
    const upcomingEvents = (events || [])
        .filter(event => event.dateTo ? event.dateTo >= today : event.dateFrom >= today)
        .sort((a, b) => a.dateFrom.localeCompare(b.dateFrom))
        .filter((_, index) => index < 3);

    return <>
        <Carousel />
        <section className="width-max">
            <div className="h-tag">Akce</div>
            <h1 className="h-title">Nadcházející akce</h1>
            <div className="h-line" />

            {(user.isEditor || user.isAdmin) && <div className="admin">
                <button onClick={() => setAddEvent(true)}><Icon path={mdiPlus} size={1} /> Přidat akci</button>
                <EditEvent show={addEvent} onClose={() => setAddEvent(false)} onChange={reload} />
            </div>}

            {isLoading && <Loading />}
            {upcomingEvents.length === 0 && <p className="info">Zatím nejsou žádné nadcházející akce.</p>}
            {upcomingEvents.length > 0 && <div className="grid">
                {upcomingEvents.map((event) => <EventPreview key={event._id} event={event} onChange={reload} />)}
            </div>}

            <Link className="button center" href="/akce">Více informací <Icon path={mdiArrowRight} size={0.9} /></Link>
        </section>

        <section className="accommodation-panel">
            <h2>Ubytování Sokol Poniklá</h2>
            <p>Zamluvte si ubytování ještě dnes</p>
            <Link className="button center" href="/ubytovani">Zamluvit ubytování</Link>
        </section>

        <section className="width-max" style={{ marginBottom: "120px" }}>
            <div className="h-tag">Galerie</div>
            <h2 className="h-title">Foto galerie</h2>
            <div className="h-line" />

            {galleriesIsLoading && <Loading />}
            {galleriesError && <p className="alert">Galerie se nepodařilo načíst. Zkuste to prosím později.</p>}
            {galleries && <Galleries galleries={galleries.filter((_, i) => i < 6)} year={Number(moment().format("YYYY"))} onChange={galleriesReload} />}

            <Link href="/fotogalerie" className="button center">Galerie <Icon path={mdiArrowRight} size={0.9} /></Link>
        </section>

        <Sponsors />
    </>;
}